module.exports = __webpack_public_path__ + "static/mlogo@2x-aa0a9ba8281e586251e85e0292e9004e.png";